import React from "react";
import Image from "next/image";
import Head from "next/head";
import PropTypes from "prop-types";

//internal import
import Layout from "@layout/Layout";
import PageHeader from "@component/header/PageHeader";

// Team data structure
const teamMembers = [{
  id: 1,
  name: "Sakib Ibn Rashid Rhivu",
  position: "Brand Ambassador",
  image: "/team/team-1.jpg",
  description: "Sakib Ibn Rashid Rhivu, also known on-air as Rhivu Rashid, is the host of Labrador Morning at Canada's public broadcaster CBC/Radio-Canada. He is the Brand Ambassador of CubeNation.\n\nRashid represents CubeNation in a positive light and by doing so helps to increase brand awareness and sales.\n\nSakib Ibn Rashid started Speedcubing back in 2013 and is the former National Champion & National Record holder of Rubik's Cube (single: 7.18 sec & average: 8.57 sec). He is best known for his undisputed dominance in the speedcubing scene of 2013-2016.",
  links: [
    { type: "WCA", url: "https://www.worldcubeassociation.org/persons/2017RHIV01" },
    { type: "CBC Listen", url: "https://www.cbc.ca/listen/live-radio/1-31-labrador-morning" }
  ]
}, {
  id: 2,
  name: "Farhanul Haque Khan",
  position: "Manager",
  image: "/team/farhan.jpg",
  description: "Farhan manages the overall business. He is the person to contact last, about order issues.\n\nFarhan has some supernatural powers in real (Uplifting a giant cheque is one of them). He is a perfectionist. Whatever you tell him to do he will say yes, but won't actually do that. Instead, he will create something which is way better than what you imagined.\n\nSome people say he is from the future because his sarcasm level is 9000 (beware of his sarcastic comments and trolls). Other than sales and marketing stuff he does graphic designing for the site. He graduated from IBA, Jahangirnagar University and now works as a Product Manager at Bevy Commerce Inc.",
  links: [
    { type: "WCA", url: "https://www.worldcubeassociation.org/persons/2017KHAN54" }
  ]
}, {
  id: 3,
  name: "Afi Noor",
  position: "Consultant",
  image: "/team/team-3.jpg",
  description: "Afi Noor is a consultant for the team currently. Formerly, he managed web development and customer behavior analysis.\n\nAfi Noor is best known for his 'Late Entry' to the cube adda as a Host. After graduating from IBA, University of Dhaka, he now works as an Analytics Engineer at Intelligent Machines Limited.\n\nHe uses the CFOP method to solve the Rubik's cube and averages below 20 seconds. He doesn't attend competitions now, but he stills works for the betterment of the community. Outside of cubing, Afi sleeps, Eats, and does things that you can't imagine.",
  links: [
        { type: "LinkedIn", url: "https://www.linkedin.com/in/afi-noor/" }
  ]
}, {
  id: 4,
  name: "Shahadat Hossain Shamim",
  position: "Co-Founder",
  image: "/team/team-4.jpg", description: "He is also head of marketing and manages the event stall sales. He also takes photographs of various events that we participate in or sponsor.\n\nShahadat graduated from Dhaka International University in CSE and now works as a Software Engineer at Brain Station 23. He has traveled to 50+ districts of Bangladesh and loves traveling. You can contact him for travel guides.\n\nOther than that, Shamim plays Bionic Commando: Rearmed, Fifa.",
  links: [
    { type: "LinkedIn", url: "https://www.linkedin.com/in/shamim3929/" }
  ]
}, {
  id: 5,
  name: "Munem Shahriar",
  position: "Production Manager",
  image: "/team/munem.jpg",
  description: "Munem is responsible for our production series. He handcrafts the cubes and places magnets inside with precise placement. We call it 'Munemization'. If a product's short description has this word, be assured, it's the best form of that cube.\n\nHe started cubing back in 2015. He uses CFOP. Other than cubing, he likes photography, PUBG and coding. He graduated from CSE, North South University.",
  links: [
    { type: "WCA", url: "https://www.worldcubeassociation.org/persons/2017SHAH13" }
  ]
}, {
  id: 6,
  name: "Muhtasim Al Farabi",
  position: "Head of Overseas",
  image: "/team/team-6.jpg",
  description: "Farabi manages our international business and makes sure that we don't miss any international wholesale orders. He closely builds our relationship with sellers so that we find the best deals possible.\n\nFarabi started cubing back in 2014, being inspired by Sakib Ibn Rashid Rhivu. Now he is one of the Top Speedcubers in the country. He is an all-rounder who solves almost all of the WCA puzzles and Ranks in Top 3 nationwide.\n\nHe graduated from the University of Arizona, USA and now works as a Software Engineer at ServiceNow.",
  links: [
    { type: "WCA", url: "https://www.worldcubeassociation.org/persons/2017FARA06" }
  ]
},
{
  id: 7,
  name: "Sizanul Islam",
  position: "Customer Success Executive",
  image: "/team/sizan.jpg",
  description: "Sizanul Islam manages our customer success team. He is responsible for ensuring that our customers have a positive experience with our products and services.\n\nSizanul started cubing back in 2016. He is a speedcuber who uses CFOP method to solve the Rubik's cube and averages below 40 seconds.\n\nHe studies BBA at Bangladesh University of Business and Technology. Outside of cubing, Sizanul enjoys playing video games, watching movies, and spending time with his family.",
  links: [
    { type: "LinkedIn", url: "https://www.linkedin.com/in/sizanul-islam-047695240" }
  ]
},
{
  id: 8,
  name: "Sourov Roy",
  position: "Customer Success Executive",
  image: "/team/sourov.jpg",
  description: "Sourov Roy is a Customer Success Executive at CubeNation. He is responsible for ensuring that our customers have a positive experience with our products and services.\n\nSourov started cubing back in 2014. He is a speedcuber who uses CFOP method to solve the Rubik's cube and averages below 25 seconds.\n\nHe studies MBA at Bangladesh University of Business and Technology. Outside of cubing, Sourov enjoys playing video games, watching movies, and spending time with his family.",
  links: [
    { type: "LinkedIn", url: "https://www.linkedin.com/in/sroysourov" }
  ]
}
];

// Modern Button Component with Icons
const ActionButton = ({ href, children, type }) => {
  const getIcon = (linkType) => {
    switch (linkType?.toLowerCase()) {
      case 'wca':
        return (
          <img
            src="/wca.svg"
            alt="WCA Logo"
            className="w-4 h-4 mr-2"
          />
        );
      case 'linkedin':
        return (
          <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z" clipRule="evenodd" />
          </svg>
        );
      case 'cbc listen':
        return (
          <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM15.657 6.343a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-1.929 3.657 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-1.18-.32-2.284-.879-3.243a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-.757.829 1 1 0 01-1.415-1.414A3.984 3.984 0 0013 10a3.983 3.983 0 00-.172-.171 1 1 0 010-1.415z" clipRule="evenodd" />
          </svg>
        );
      default:
        return (
          <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" clipRule="evenodd" />
          </svg>
        );
    }
  };

  return (
    <a
      className="inline-flex items-center min-w-32 rounded-md bg-slate-800 py-2 px-4 border border-transparent text-center text-sm text-white transition-all shadow-md hover:shadow-lg focus:bg-slate-700 focus:shadow-none active:bg-slate-700 hover:bg-slate-700 active:shadow-none"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {getIcon(type)}
      {children}
    </a>
  );
};

// Modern Team Card Component
const TeamCard = ({ member }) => {
  return (
    <div className="flex flex-col bg-white shadow-sm border border-slate-200 rounded-lg my-6 w-full max-w-sm mx-auto">
      <div className="m-2.5 overflow-hidden rounded-md h-80 flex justify-center items-center">
        <Image
          width={400}
          height={320}
          src={member.image}
          alt={member.name}
          className="w-full h-full object-cover"
          placeholder="blur"
          blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
        />
      </div>      <div className="px-6 pt-6 pb-2 text-center flex-grow flex flex-col">
        <h4 className="mb-1 text-xl font-semibold text-slate-800">
          {member.name}
        </h4>
        <p className="text-sm font-semibold text-slate-500 uppercase">
          {member.position}
        </p>
        
              {member.links.length > 0 && (
        <div className="flex justify-center px-4 pt-2 pb-2 gap-3 flex-wrap">
          {member.links.map((link) => (
            <ActionButton
              key={`${member.id}-${link.type}`}
              href={link.url}
              type={link.type}
            >
              {link.type}
            </ActionButton>
          ))}
        </div>
      )}
        <div className="text-base text-slate-600 mt-4 mb-2 font-light text-left whitespace-pre-line flex-grow">
          {member.description}
        </div>      </div>

    </div>
  );
};

const AboutUs = () => {
  return (
    <>
      <Layout title="About Us" description="This is about us page">
        <Head>
          <meta property="og:title" content="About us - CubeNation" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.cubenationshop.com/about-us" />
          <meta property="og:image" content="/facebook-page.png" />
          <meta
            property="og:description"
            content="CubeNation is one of the largest Speed cube shops in BD. It's simply a Puzzle Bazaar & cube collection store!"
          />
        </Head>
        <PageHeader title="About Us" />

        <div className="bg-white">
          <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-4 sm:px-10">
            <div className="grid grid-flow-row lg:grid-cols-2 gap-4 lg:gap-16 items-center">
              <div className="">
                <h3 className="text-xl lg:text-3xl mb-2 font-serif font-semibold">
                  Welcome to CubeNation
                </h3>
                <div className="mt-3 text-base opacity-90 leading-7">
                  <p>
                    Cube Nation is the largest Cube store in Bangladesh. We
                    started our journey back in August 2016 for the betterment
                    of the Bangladesh cubing community. We sell everything
                    related to speedcubing, puzzle-collecting, accessories, and
                    maintenance items. With having multiple speedcubers in the
                    management team, we provide you with an up-to-date solution
                    to your puzzle-related problems.
                  </p>

                  <p>
                    Our mission is to popularize puzzles among the people and
                    build a safe haven for puzzlers to rest in. While, our
                    vision is to build a haven for puzzlers of all sorts. We are
                    constantly working toward this goal.
                  </p>
                </div>
                <div className="grid md:grid-cols-2 gap-6 lg:grid-cols-2 xl:gap-6 mt-8">
                  <div className="p-8 bg-indigo-50 shadow-sm rounded-lg">
                    <span className="text-3xl block font-extrabold font-serif mb-4 text-gray-800">
                      9.7k
                    </span>
                    <h4 className="text-lg font-serif font-bold mb-1">
                      Original Puzzles
                    </h4>
                    <p className="mb-0 opacity-90 leading-7">
                      Right from manufacturers overseas.{" "}
                    </p>
                  </div>
                  <div className="p-8 bg-indigo-50 shadow-sm rounded-lg">
                    <span className="text-3xl block font-extrabold font-serif mb-4 text-gray-800">
                      22,000
                    </span>
                    <h4 className="text-lg font-serif font-bold mb-1">
                      Orders fulfilled
                    </h4>
                    <p className="mb-0 opacity-90 leading-7">
                      All over Bangladesh from various puzzlers as of 2025.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-10 lg:mt-0">
                <Image
                  width={920}
                  height={750}
                  src="/about-us.webp"
                  alt="logo"
                  placeholder="blur"
                  blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                />
              </div>
            </div>
            <div className="mt-10 lg:mt-16 text-base opacity-90 leading-7">
              <p>
                It all started in August 2016, by an agonized Cuber who wanted a
                cubing-related shop, that could give him the necessary specs
                that he needed at an understandable price. It started with
                Zero-Investment(allegedly) by taking pre-orders from the
                customers. Like most of the businesses, it failed miserably on
                its first attempt. The calculation for the shipment and custom
                tax was wrong. We had to bear a loss of 50k and suddenly, we
                were in a very bad position. We thought of going rogue too.
                Luckily, we received some funding. We tried again after we
                finally understood the import regulations. Then we dealt with
                our suppliers in China to get the cubes, created a website, made
                visiting cards, purchased shipping materials, and other related
                stuff. Everything was set. An anonymous philosopher once said,
              </p>
              <p>
                <b>"Just Name it!"</b>{" "}
              </p>
              <p>
                So we had to name our venture. We searched for good names for
                days. Yet, we couldn't find any that would suit us. Out of the
                blue, one of our cuber friends, Sreshtho, on August 27th, 2016,
                voiced the word "CubeNation". Rest is history. Over time,
                Cubenation became very popular.
              </p>
            </div>
            <div className="mt-10 lg:mt-12 flex flex-col sm:grid gap-4">
              <Image
                width={1920}
                height={570}
                src="/about-banner.webp"
                alt="logo"
                className="block rounded-lg"
                placeholder="blur"
                blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
              />
            </div>
          </div>

          {/* Modern Team Section */}
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 lg:py-20 py-10">
            <div className="max-w-screen-2xl mx-auto px-3 sm:px-10">
              <div className="relative flex flex-col sm:flex-row sm:items-end justify-between mb-12">
                <div className="max-w-2xl">
                  <h3 className="text-xl lg:text-4xl mb-4 font-serif font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent">
                    Meet Our Amazing Team
                  </h3>
                  <p className="mt-2 md:mt-3 font-normal block text-lg text-gray-600 leading-relaxed">
                    We're passionate cubers and innovators who tackle challenges with creativity and determination.
                    Each team member brings unique expertise to make CubeNation the best it can be.
                  </p>
                </div>
              </div>              {/* Team Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 auto-rows-fr">
                {teamMembers.map((member) => (
                  <TeamCard key={member.id} member={member} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

// PropTypes for better type checking
ActionButton.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  type: PropTypes.string
};

TeamCard.propTypes = {
  member: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    }))
  }).isRequired
};

export default AboutUs;
